@if (!displayOnlyMetaFunctionalities) {
  <mat-form-field
    [ngClass]="{ autocomplete: appearance === 'outline' }"
    [ngStyle]="{ opacity: disabled ? '0.5' : '1' }"
    style="width: 100%"
    [appearance]="appearance"
    >
    <mat-label>{{ label }}</mat-label>
    <input matInput style="display: none" [formControl]="textInput" />
    <ng-container *ngTemplateOutlet="metaFunctionality"></ng-container>
    <button matSuffix class="material-icons" mat-icon-button (click)="onClick()">
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    @if (textInput.hasError('required') && !hideError) {
      <mat-error>
        {{ !!customError ? customError : label + ' is required' }}
      </mat-error>
    }
  </mat-form-field>
} @else {
  <div (click)="onClick($event)">
    <input
      type="text"
      matInput
      [placeholder]="placeHolder"
      #autocompleteInput
      [matAutocomplete]="auto"
      [formControl]="textInput"
      [readonly]="!freeTextEnabled || disabled || readonly"
      [disabled]="disabled"
      [required]="required"
      (keyup)="onFreeTextInput(autocompleteInput.value)"
      (keyup.enter)="onFreeTextSelect()"
      (blur)="onFreeTextSelect()"
      autocomplete="disabled"
      (focus)="focusChanged(true, auto)"
      (blur)="focusChanged(false, auto)"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        class="single-autocomplete"
        panelWidth="auto"
        (opened)="focusChanged(true, auto)"
        (closed)="focusChanged(false, auto)"
        >
        @if (!disabled) {
          <span>
            <div
              class="input-container"
              style="display: flex; justify-content: space-between"
              >
              <input
                type="text"
                matInput
                [placeholder]="dropdownPlaceholder"
                #innerInput
                class="inner-input"
                [formControl]="filterInput"
                autocomplete="disabled"
                />
                @if (filterInput.value) {
                  <button
                    mat-icon-button
                    (click)="filterClear(); optionPanelOpen()"
                    matTooltip="Clear"
                    >
                    <mat-icon
                      class="clear-icon"
                      [ngStyle]="{ cursor: readonly ? 'default' : 'pointer' }"
                      >
                      clear
                    </mat-icon>
                  </button>
                }
              </div>
              @if (loaderText) {
                <div>
                  <mat-option disabled>
                    <span class="d-flex align-items-center justify-content-between">
                      <span>{{ loaderText }}</span>
                      <mat-spinner diameter="25"></mat-spinner>
                    </span>
                  </mat-option>
                </div>
              }
              @if (isFieldsLoading) {
                <div>
                  <mat-option disabled>
                    <div class="px-0 py-2 m-0 flex-container">
                      <h3
                        class="pb-2 skeleton-load-item field-name-skeleton-middle"
                      ></h3>
                    </div>
                  </mat-option>
                </div>
              }
              @if (!loaderText && !isFieldsLoading) {
                <div>
                  @if (filteredOptionsArray && filteredOptionsArray.length === 0) {
                    <mat-option
                      class="mat-option-autocomplete"
                      disabled
                      >{{ optionsEmpty }}</mat-option
                      >
                  }
                  @if (
                    multiSelect &&
                    !hideTheAllOption &&
                    filteredOptionsArray &&
                    filteredOptionsArray.length !== 0
                    ) {
                    <mat-option
                      class="mat-option-autocomplete"
                      (click)="onSelectAll()"
                      >
                      @if (multiSelect) {
                        <span matTooltip="All"> All </span>
                      }
                    </mat-option>
                  }
                  @if (
                    multiSelect &&
                    !optionItemDisabled &&
                    !hideTheAllOption &&
                    filteredOptionsArray &&
                    filteredOptionsArray.length !== 0
                    ) {
                    <mat-option
                      class="mat-option-autocomplete"
                      (click)="onSelectAll()"
                      >
                      <span>
                        <mat-checkbox
                          color="accent"
                          [checked]="selectAll"
                          disabled
                          [class.mat-checkbox-disabled]="false"
                          >
                          All
                        </mat-checkbox>
                      </span>
                    </mat-option>
                  }
                  @for (option of filteredOptions | async; track option) {
                    <mat-option
                      class="mat-option-autocomplete"
                      [value]="option.value"
                      (click)="onSelect(option)"
                      >
                      @if (!multiSelect) {
                        <span
                          [matTooltip]="option.displayValue || option.value"
                          >
                          {{ option.displayValue ?? option.value }}
                        </span>
                      }
                      @if (multiSelect) {
                        <span>
                          <mat-checkbox
                            color="accent"
                            [checked]="isOptionSelected(option)"
                            class="readonly-checkbox"
                            >
                            {{ option.displayValue ?? option.value }}
                          </mat-checkbox>
                        </span>
                      }
                    </mat-option>
                  }
                </div>
              }
            </span>
          }
        </mat-autocomplete>
      </div>
    }

    <ng-template #metaFunctionality let-formControl="formControl">
      <div (click)="onClick($event)">
        <input
          type="text"
          matInput
          [placeholder]="placeHolder"
          #autocompleteInput
          [matAutocomplete]="auto"
          [formControl]="textInput"
          [readonly]="!freeTextEnabled || disabled || readonly"
          [disabled]="disabled"
          [required]="required"
          (keyup)="onFreeTextInput(autocompleteInput.value)"
          (keyup.enter)="onFreeTextSelect()"
          (blur)="onFreeTextSelect()"
          autocomplete="disabled"
          (focus)="focusChanged(true, auto)"
          (blur)="focusChanged(false, auto)"
          />

          <mat-autocomplete
            autoActiveFirstOption
            #auto="matAutocomplete"
            class="single-autocomplete"
            panelWidth="auto"
            (opened)="focusChanged(true, auto)"
            (closed)="focusChanged(false, auto)"
            >
            @if (!disabled) {
              <span>
                <div
                  class="input-container"
                  style="display: flex; justify-content: space-between"
                  >
                  <input
                    type="text"
                    matInput
                    [placeholder]="dropdownPlaceholder"
                    #innerInput
                    class="inner-input"
                    [formControl]="filterInput"
                    autocomplete="disabled"
                    />
                    @if (filterInput.value) {
                      <button
                        mat-icon-button
                        (click)="filterClear(); optionPanelOpen()"
                        matTooltip="Clear"
                        >
                        <mat-icon
                          class="clear-icon"
                          [ngStyle]="{ cursor: readonly ? 'default' : 'pointer' }"
                          >
                          clear
                        </mat-icon>
                      </button>
                    }
                  </div>
                  @if (loaderText) {
                    <div>
                      <mat-option disabled>
                        <span class="d-flex align-items-center justify-content-between">
                          <span>{{ loaderText }}</span>
                          <mat-spinner diameter="25"></mat-spinner>
                        </span>
                      </mat-option>
                    </div>
                  }
                  @if (isFieldsLoading) {
                    <div>
                      <mat-option disabled>
                        <div class="px-0 py-2 m-0 flex-container">
                          <h3
                            class="pb-2 skeleton-load-item field-name-skeleton-middle"
                          ></h3>
                        </div>
                      </mat-option>
                    </div>
                  }
                  @if (!loaderText && !isFieldsLoading) {
                    <div>
                      @if (filteredOptionsArray && filteredOptionsArray.length === 0) {
                        <mat-option
                          class="mat-option-autocomplete"
                          disabled
                          >{{ optionsEmpty }}</mat-option
                          >
                      }
                      @if (
                        multiSelect &&
                        !hideTheAllOption &&
                        filteredOptionsArray &&
                        filteredOptionsArray.length !== 0
                        ) {
                        <mat-option
                          class="mat-option-autocomplete"
                          (click)="onSelectAll()"
                          >
                          @if (multiSelect) {
                            <span matTooltip="All"> All </span>
                          }
                        </mat-option>
                      }
                      @if (
                        multiSelect &&
                        !optionItemDisabled &&
                        !hideTheAllOption &&
                        filteredOptionsArray &&
                        filteredOptionsArray.length !== 0
                        ) {
                        <mat-option
                          class="mat-option-autocomplete"
                          (click)="onSelectAll()"
                          >
                          <span>
                            <mat-checkbox
                              color="accent"
                              [checked]="selectAll"
                              class="readonly-checkbox"
                              >
                              All
                            </mat-checkbox>
                          </span>
                        </mat-option>
                      }
                      @for (option of filteredOptions | async; track option) {
                        <mat-option
                          class="mat-option-autocomplete"
                          [value]="option.value"
                          (click)="onSelect(option)"
                          >
                          @if (!multiSelect) {
                            <span
                              [matTooltip]="option.displayValue || option.value"
                              >
                              {{ option.displayValue ?? option.value }}
                            </span>
                          }
                          @if (multiSelect) {
                            <span>
                              <mat-checkbox
                                color="accent"
                                [checked]="isOptionSelected(option)"
                                class="readonly-checkbox"
                                >
                                {{ option.displayValue ?? option.value }}
                              </mat-checkbox>
                            </span>
                          }
                        </mat-option>
                      }
                    </div>
                  }
                </span>
              }
            </mat-autocomplete>
          </div>
        </ng-template>
